import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    isDraggable: false,
    showMarquee: false,
    isWindowFocused: true,
    isStickyForm: false,
    windowBlurTime: 0,
    default_layouts: {
        lg: [
            {
                x: 0,
                y: 0,
                w: 4,
                h: 22,
                i: "option-chain",
            },
            {
                x: 4,
                y: 0,
                w: 4,
                h: 22,
                i: "NIFTY",
            },
            {
                x: 8,
                y: 0,
                w: 4,
                h: 22,
                i: "BANKNIFTY",
            },
            {
                x: 4,
                y: 22,
                w: 4,
                h: 10,
                i: "fii",
            },
            {
                x: 8,
                y: 22,
                w: 4,
                h: 10,
                i: "fo-momentum",
            },
            {
                x: 0,
                y: 22,
                w: 4,
                h: 10,
                i: "vix",
            },
            {
                x: 0,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-top-stocks",
            },
            {
                x: 4,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-built-up-breadth",
            },
            {
                x: 8,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-hi-lo",
            },
        ],
        md: [
            {
                x: 0,
                y: 0,
                w: 4,
                h: 22,
                i: "option-chain",
            },
            {
                x: 4,
                y: 0,
                w: 4,
                h: 22,
                i: "NIFTY",
            },
            {
                x: 8,
                y: 0,
                w: 4,
                h: 22,
                i: "BANKNIFTY",
            },
            {
                x: 4,
                y: 22,
                w: 4,
                h: 10,
                i: "fii",
            },
            {
                x: 8,
                y: 22,
                w: 4,
                h: 10,
                i: "fo-momentum",
            },
            {
                x: 0,
                y: 22,
                w: 4,
                h: 10,
                i: "vix",
            },
            {
                x: 0,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-top-stocks",
            },
            {
                x: 4,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-built-up-breadth",
            },
            {
                x: 8,
                y: 32,
                w: 4,
                h: 10,
                i: "quants-hi-lo",
            },
        ],
        sm: [
            {
                x: 0,
                y: 0,
                w: 6,
                h: 22,
                i: "option-chain",
            },
            {
                x: 6,
                y: 0,
                w: 6,
                h: 22,
                i: "NIFTY",
            },
            {
                x: 0,
                y: 20,
                w: 6,
                h: 22,
                i: "BANKNIFTY",
            },
            {
                x: 6,
                y: 22,
                w: 6,
                h: 10,
                i: "vix",
            },
            {
                x: 0,
                y: 22,
                w: 6,
                h: 10,
                i: "fii",
            },
            {
                x: 6,
                y: 22,
                w: 6,
                h: 10,
                i: "fo-momentum",
            },
            {
                x: 6,
                y: 22,
                w: 6,
                h: 10,
                i: "quants-top-stocks",
            },
            {
                x: 0,
                y: 22,
                w: 6,
                h: 10,
                i: "quants-built-up-breadth",
            },
            {
                x: 6,
                y: 22,
                w: 6,
                h: 10,
                i: "quants-hi-lo",
            },
        ],
        xs: [
            {
                x: 0,
                y: 0,
                w: 12,
                h: 22,
                i: "option-chain",
            },
            {
                x: 0,
                y: 22,
                w: 12,
                h: 20,
                i: "NIFTY",
            },
            {
                x: 0,
                y: 42,
                w: 12,
                h: 20,
                i: "BANKNIFTY",
            },
            {
                x: 0,
                y: 62,
                w: 12,
                h: 10,
                i: "vix",
            },
            {
                x: 0,
                y: 72,
                w: 12,
                h: 10,
                i: "fii",
            },
            {
                x: 0,
                y: 82,
                w: 12,
                h: 10,
                i: "fo-momentum",
            },
            {
                x: 0,
                y: 92,
                w: 12,
                h: 10,
                i: "quants-top-stocks",
            },
            {
                x: 0,
                y: 102,
                w: 12,
                h: 10,
                i: "quants-built-up-breadth",
            },
            {
                x: 0,
                y: 112,
                w: 12,
                h: 10,
                i: "quants-hi-lo",
            },
        ],
        xxs: [
            {
                x: 0,
                y: 0,
                w: 12,
                h: 22,
                i: "option-chain",
            },
            {
                x: 0,
                y: 22,
                w: 12,
                h: 20,
                i: "NIFTY",
            },
            {
                x: 0,
                y: 42,
                w: 12,
                h: 20,
                i: "BANKNIFTY",
            },
            {
                x: 0,
                y: 62,
                w: 12,
                h: 10,
                i: "vix",
            },
            {
                x: 0,
                y: 72,
                w: 12,
                h: 10,
                i: "fii",
            },
            {
                x: 0,
                y: 82,
                w: 12,
                h: 10,
                i: "fo-momentum",
            },
            {
                x: 0,
                y: 92,
                w: 12,
                h: 10,
                i: "quants-top-stocks",
            },
            {
                x: 0,
                y: 102,
                w: 12,
                h: 10,
                i: "quants-built-up-breadth",
            },
            {
                x: 0,
                y: 112,
                w: 12,
                h: 10,
                i: "quants-hi-lo",
            },
        ],
    },
    fno_symbols: [],
};
export const appSlice = createSlice({
    name: "app",
    initialState: initialState,
    reducers: {
        resetToDefault(state) {
            state.default_layouts = initialState.default_layouts;
        },
        updateLayouts(state, action) {
            state.default_layouts = action.payload;
        },
        setFNOSymbols(state, action) {
            state.fno_symbols = action.payload;
        },
        enableDragging(state) {
            state.isDraggable = true;
        },
        disableDragging(state) {
            state.isDraggable = false;
        },
        enableMarquee(state) {
            state.showMarquee = true;
        },
        disableMarquee(state) {
            state.showMarquee = false;
        },
        onWindowFocus(state) {
            state.isWindowFocused = true;
        },
        onWindowBlur(state) {
            state.isWindowFocused = false;
        },
        enableStickyForm(state, action) {
            state.isStickyForm = action.payload;
        },
        onWindowBlurTime(state, action) {
            state.windowBlurTime = action.payload;
        },
    },
});
const { actions, reducer } = appSlice;
export const { resetToDefault, setFNOSymbols, enableDragging, disableDragging, enableMarquee, disableMarquee, updateLayouts, onWindowFocus, onWindowBlur, onWindowBlurTime, enableStickyForm, } = actions;
export default reducer;
